module.exports = __webpack_public_path__ + "img/jjqd-back.d0656aaa.png";